import React, { useEffect, useState } from "react";
import moment from "moment-timezone";

const DateComponent = () => {
    const timezone = JSON.parse(localStorage.getItem("countryData")).timezone;
	let [dateTime, setDateTime] = useState(moment.tz(timezone))

	useEffect(() => {
        const intervalId = setInterval(() => {
            setDateTime(moment.tz(timezone));
        }, 1000);
        return () => {
            clearInterval(intervalId);
        };
	}, []);

	return (
		<div className="date" style={{ display: "flex", alignItems: "center", marginRight: 32 }}>
			<div
				className="day"
				style={{
					display: "inline-block",
					fontSize: "25px",
					fontWeight: "bold",
					lineHeight: "40px",
					color: "#ffffff",
				}}>
				{dateTime.format("hh:mm")}
			</div>
			<span style={{ marginLeft: 10 }}>
				<p
					className="month"
					style={{
						margin: "0 0 2px",
						fontSize: "10px",
						lineHeight: "14px",
						color: "#ffffff",
					}}>
					{dateTime.format("A")}, {JSON.parse(localStorage.getItem("countryData")).country_name?.toUpperCase()}
				</p>
				<p
					className="year"
					style={{
						margin: "0",
						fontSize: "10px",
						lineHeight: "14px",
						color: "#ffffff",
					}}>
					{dateTime.format("DD MMM YYYY")}
				</p>
			</span>
		</div>
	);
};

export default DateComponent;
